import './ReactProductComparisonTeaser.scss'
import { ButtonTypes } from '@cox/core-ui8//dist/Button'

import { SKELETON_ITEMS } from '../../../constants'
import { Placeholder } from '../../shared/ReactBootstrap'

const ReactProductComparisonTeaserSkeleton = () => {
  return (
    <div>
      <div
        data-testid={`react-product-comparison-teaser-card-sm`}
        className='react-product-comparison-teaser-container react-product-comparison-teaser-card-sm'
      >
        <div className='product-teaser-section1'>
          <div className='carousel-badge'>
            <Placeholder
              as={'span'}
              style={{ height: '20px', width: '100px', backgroundColor: 'grey', borderRadius: '20px' }}
            />
          </div>
          <Placeholder className='eyebrow' xs={4} />
          <Placeholder xs={6} />
          <Placeholder className='additional-note' xs={8} />
        </div>
        <hr className='teaser-section-divider' />
        <div className='product-teaser-section2'>
          <Placeholder className='description' xs={7} />
          <div className='bullet-list'>
            {SKELETON_ITEMS.map((bullet: string) => {
              return (
                <div className='bullet-list-item' key={JSON.stringify(bullet)}>
                  <div className='bullet-icon skeleton-img-placeholder' />
                  <Placeholder className='bullet-text' xs={7} />
                </div>
              )
            })}
          </div>
        </div>
        <hr className='teaser-section-divider' />
        <div className='product-teaser-section3'>
          <div className={`react-price-container`}>
            <Placeholder className='details-price' xs={4} />
            <Placeholder className='scratch-price' xs={4} />
            <Placeholder className='product-term m-0' xs={6} />
          </div>
        </div>
        <hr className='teaser-section-divider' />
        <div className='product-teaser-section4'>
          <div className='product-comparision-teaser-buttons' style={{ display: 'flex', flexDirection: 'column' }}>
            <Placeholder.Button xs={8} variant={ButtonTypes.PRIMARY} />
            <Placeholder.Button xs={8} variant={ButtonTypes.SECONDARY} />
          </div>
        </div>
      </div>

      <div
        data-testid={`react-product-comparison-teaser-card-lg`}
        className='react-product-comparison-teaser-container react-product-comparison-teaser-card-lg'
      >
        <div className='product-teaser-section1-lg'>
          <div className='badge-placeholder'></div>
          <div className='bullet-list'>
            {SKELETON_ITEMS.map((bullet: string) => {
              return (
                <div className='bullet-list-item' key={JSON.stringify(bullet)}>
                  <div className='bullet-icon skeleton-img-placeholder' />
                  <Placeholder className='bullet-text' xs={12} style={{ width: '100px' }} />
                </div>
              )
            })}
          </div>
        </div>
        <hr className='teaser-section-divider' />
        <div className='product-teaser-section2-lg'>
          <div className='product-teaser-section2-part1'>
            <div className='product-teaser-section2-col1'>
              <div className='heading-icon-details'>
                <div>
                  <Placeholder xs={4} />
                  <Placeholder xs={2} />
                </div>
              </div>
              <Placeholder className='additional-note cox-text-paragraph4-medium' xs={6} />
            </div>
            <div className='product-teaser-section2-col2'>
              <Placeholder xs={5} />
              <Placeholder className='description' xs={12} />
              <Placeholder className='description' xs={12} />
              <Placeholder className='description' xs={12} />
            </div>
            <div className='product-teaser-section2-col3'>
              <div className='price-dropdown-section'>
                <div className={`react-price-container`}>
                  <button style={{ border: 'none', background: 'none', padding: '0' }}>
                    <div className='react-price' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <Placeholder xs={4} />
                      <Placeholder xs={6} />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className='product-teaser-section2-part2'>
            <div
              className='product-teaser-buttons-section'
              style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
            >
              <Placeholder.Button xs={12} variant={ButtonTypes.PRIMARY} style={{ width: '200px' }} />
              <Placeholder.Button xs={12} variant={ButtonTypes.SECONDARY} style={{ width: '200px' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReactProductComparisonTeaserSkeleton
